module.exports = __webpack_public_path__ + "static/media/stufflogo.a12ea72e.png";